<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="Create Return & Cancellation Policy"
                :hasSearch="false"
                :hasCreate="false"
                :hasClear="false"
                :hasReload="false"
                :hasback="true"
                @back-press="$router.push({ path: '/setup/policy' })"
            />
        </b-col>
        <b-col md="12">
            <b-card class="custome-card">
                <ValidationObserver ref="observer">
                    <form>
                        <b-row>
                            <b-col md="6" class="mt-2">
                                <label for="productType">Product Type </label>
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Product Type"
                                >
                                    <multiselect
                                        v-model="productType"
                                        tag-placeholder="Add this as new product type"
                                        placeholder="Select Product Type"
                                        label="name"
                                        track-by="_id"
                                        :options="productTypeList"
                                        :multiple="true"
                                        :taggable="false"
                                        :open-direction="'bottom'"
                                    ></multiselect>
                                    <span
                                        class="validate-error"
                                        style="color: red"
                                        >{{ errors[0] }}</span
                                    >
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" class="mt-2">
                                <label for="planName"
                                    >Return & Replacement Window Days</label
                                >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Return & Replacement Window Days"
                                >
                                    <b-form-input
                                        id="planName"
                                        inputType="text"
                                        placeholder="Enter Return Window(in days)"
                                        v-model="returnWindow"
                                    />
                                    <span
                                        class="validate-error"
                                        style="color: red"
                                        >{{ errors[0] }}</span
                                    >
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4" class="mt-4">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Allow Return"
                                    v-model="allowReturn"
                                >
                                </v-switch>
                            </b-col>
                            <b-col md="4" class="mt-4">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Allow Replacement"
                                    v-model="allowReplacement"
                                >
                                </v-switch>
                            </b-col>
                            <b-col md="4" class="mt-4">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Return Approval Require"
                                    v-model="returnApproval"
                                >
                                </v-switch>
                            </b-col>
                            <b-col md="6" class="mt-4">
                                <div class="d-flex align-items-center">
                                    <label class="mb-0 font-weight-bold"
                                        >Refund Mode:
                                    </label>
                                    <b-form-checkbox-group
                                        id="refund-mode-group"
                                        v-model="selectedRefundMode"
                                        :options="refundModeOptions"
                                        name="refund-modes"
                                    ></b-form-checkbox-group>
                                </div>
                            </b-col>
                            <b-col md="6" class="mt-4">
                                <div class="d-flex align-items-center">
                                    <label class="mb-0"
                                        >Allow Cancellation:
                                    </label>
                                    <b-form-radio-group
                                        id="cancellation-group"
                                        v-model="selectedCancellation"
                                    >
                                        <b-form-radio value="BEFORE_APPROVAL"
                                            >Before Approval</b-form-radio
                                        >
                                        <b-form-radio value="BEFORE_DELIVERY"
                                            >Before Delivery</b-form-radio
                                        >
                                    </b-form-radio-group>
                                </div>
                            </b-col>
                            <b-col class="mt-4">
                                <label>Return & Replacement Policy</label>
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Return & Replacement Policy"
                                >
                                    <textarea
                                        rows="4"
                                        cols="30"
                                        id="title"
                                        class="form-control custom-transform-class"
                                        inputType="text"
                                        maxlength="300"
                                        v-model="note"
                                    ></textarea>
                                    <span
                                        class="validate-error"
                                        style="color: red"
                                        >{{ errors[0] }}</span
                                    >
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <div class="text-center mb-0 p-4">
                                    <button
                                        type="button"
                                        class="text-uppercase btn btn-sm btn-danger mr-2 action-btn "
                                        @click="
                                            $router.push({
                                                name: 'Return & Cancellation Policy',
                                            })
                                        "
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        class="text-uppercase btn btn-sm btn-primary  action-btn "
                                        classic=" btn-primary"
                                        text="Update"
                                        @click="handleSubmit"
                                    >
                                        Save
                                    </button>
                                </div>
                            </b-col>
                        </b-row>
                    </form>
                </ValidationObserver>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
export default {
    name: "Create Return Policy",
    data() {
        return {
            productTypeList: [],
            productType: "",
            selectedRefundMode: [],
            allowReturn: false,
            allowReplacement: false,
            returnWindow: "",
            replacementWindow: "",
            returnApproval: false,
            refundMode: "",
            allowCancelation: "",
            note: "",
            selectedCancellation: null,
            catalogId: "",
            refundModeOptions: [
                { text: "Original Payment", value: "ORIGINAL" },
                { text: "Wallet", value: "WALLET" },
            ],
        };
    },
    components: {
        ComponentHeader,
        ebButton,
        ValidationProvider,
        ValidationObserver,
    },
    computed: {},
    methods: {
        async productList() {
            let res = await this.$store.dispatch(
                "catalog/fetchCatalogDataByParam",
                "",
            );
            this.productTypeList = res.data.response.filter(
                (x) => x.isProductType === true,
            );
        },
        async handleSubmit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            const payload = {
                catalogId: this.productType.map((item) => item._id),
                provider: this.$currentUserData.catalogInfo[0]._id,
                allowReturn: this.allowReturn,
                allowReplacement: this.allowReplacement,
                returnWindowDays: this.returnWindow,
                approvalRequired: this.returnApproval,
                refundMode: this.selectedRefundMode,
                pickupRequired: false,
                notes: this.note,
            };
            this.$store
                .dispatch("returnPolicy/createReturnPolicy", payload)
                .then(() => {
                    this.$swal({
                        title: "Success",
                        text: "Return & Cancellation policy created successfully!!",
                        type: "success",
                    });
                    this.$router.push({
                        name: "Return & Cancellation Policy",
                    });
                })
                .catch((error) => {
                    console.error("Error creating return policy:", error);
                });
        },
    },
    mounted() {
        this.productList();
    },
};
</script>
<style scoped>
.radio-align {
    margin-top: 2px !important;
}.action-btn {
  width: 100px;  
  height: 35px;
}
</style>
